import {all} from 'redux-saga/effects'
import {watchDealers} from './dealers'
import {watchFetchMainServices, watchSaveMainServices} from './mainServices'
import {watchFetchTires, watchSaveTires} from './tires'
import {watchFetchUsers} from './users'
import {watchLogin} from './authentication'
import {watchFetchInterventions, watchFetchInterventionsOverview} from "./interventions";
import {watchFetchDistinctAdvisors} from "./advisors";
import {watchFetchServices, watchFetchServicesRepair, watchSaveServices} from "./services";
import {watchFetchMobility, watchSaveMobility} from "./mobility";
import {watchFetchPictures} from "./pictures";
import {watchFetchPlanningManagement, watchSavePlanningManagement} from "./planningManagement";
import {watchNotifications} from "./notifications";
import {watchFetchOpeningHours, watchSaveOpeningHours} from "./openingHours";
import {watchFetchMonthlyPlanning, watchSaveMonthlyPlanning} from "./monthlyPlanning";
import {watchFetchDealerInformation} from "./dealer";
import {watchFetchRentalPlanning, watchSaveRentalPlanning} from "./rentalPlanning";
import {watchFetchRentalVehicles} from "./rentals";
import {watchIntervention} from "./intervention";
import {watchJourneyComment} from "./journeyComment";
import {watchIdentity} from "./journeyIdentityDocument";
import {watchFetchInterventionComment, watchSaveInterventionComment} from "./interventionComment";
import {watchFetchAvailabilities} from "./availabilitiesSaga";
import {watchRentalPark} from "./rentalPark";
import {watchDeleteJourneyDocuments, watchFetchJourneyDocuments, watchSaveJourneyDocuments} from "./journeyDocument";
import {watchConversation} from "./conversation";
import {watchAssignRentalVehicle, watchDeleteRentalVehicle, watchFetchRentalContract, watchSaveRentalVehicle, watchUnassignRentalVehicle, watchUpdateRentalVehicle,} from "./rental";
import {watchDeleteJourneyTireOffers, watchFetchJourneyTireOffers, watchSaveJourneyTireOffers} from "./journeyTireOffers";
import {watchDeliverRentalVehicle, watchFetchRentalDeliveryPlanning, watchFetchRentalReporting} from "./rentalReporting";
import {watchUpdateJourneyMobility, watchUpdateJourneyReception, watchUpdateJourneyServices} from "./journeyProperties";
import {watchUpdateJourneyVehicle} from "./journeyVehicle";
import {watchFetchWheelsExchangeConfig} from "./wheelsExchangeConfig";
import {watchFetchWheelsExchangePlanning} from './wheelsExchangePlanning';
import {watchFetchFrontendConfig} from "./config";
import {watchFetchDealerConfigurationCheck} from "./dealerConfigurationCheck";
import {watchFetchCustomerJourneyInformation} from "./customerJourney";
import {watchSavePublicContext} from './publicContext'
import {watchSteps} from './stepper'
import {watchFetchFleetbackInterventions} from "./fleetback";
import {watchPolicyDocument} from "./consent";
import {watchFetchCustomer} from "./callCenter";
import {watchFetchLeasingCompanies} from "./leasingCompanies";
import {watchDealerPlanningConfiguration} from "./planningConfigurationSaga";

export default function* rootSaga() {
  yield all([
    watchFetchLeasingCompanies(),
    watchFetchCustomer(),
    watchDealers(),
    watchFetchMobility(),
    watchSaveMobility(),
    watchFetchMainServices(),
    watchSaveMainServices(),
    watchFetchTires(),
    watchSaveTires(),
    watchFetchUsers(),
    watchFetchInterventions(),
    watchFetchInterventionsOverview(),
    watchFetchDistinctAdvisors(),
    watchFetchServices(),
    watchFetchServicesRepair(),
    watchSaveServices(),
    watchFetchPictures(),
    watchFetchPlanningManagement(),
    watchSavePlanningManagement(),
    watchFetchOpeningHours(),
    watchSaveOpeningHours(),
    watchFetchMonthlyPlanning(),
    watchSaveMonthlyPlanning(),
    watchFetchDealerInformation(),
    watchDealerPlanningConfiguration(),
    watchFetchRentalPlanning(),
    watchSaveRentalPlanning(),
    watchLogin(),
    watchNotifications(),
    watchIntervention(),
    watchUpdateJourneyServices(),
    watchUpdateJourneyMobility(),
    watchUpdateJourneyReception(),
    watchJourneyComment(),
    watchUpdateJourneyVehicle(),
    watchFetchInterventionComment(),
    watchSaveInterventionComment(),
    watchIdentity(),
    watchFetchJourneyDocuments(),
    watchSaveJourneyDocuments(),
    watchDeleteJourneyDocuments(),
    watchFetchJourneyTireOffers(),
    watchSaveJourneyTireOffers(),
    watchDeleteJourneyTireOffers(),
    watchFetchAvailabilities(),
    watchFetchRentalVehicles(),
    watchSaveRentalVehicle(),
    watchUpdateRentalVehicle(),
    watchDeleteRentalVehicle(),
    watchAssignRentalVehicle(),
    watchFetchRentalContract(),
    watchUnassignRentalVehicle(),
    watchRentalPark(),
    watchConversation(),
    watchFetchRentalDeliveryPlanning(),
    watchFetchRentalReporting(),
    watchDeliverRentalVehicle(),
    watchFetchWheelsExchangeConfig(),
    watchFetchWheelsExchangePlanning(),
    watchFetchFrontendConfig(),
    watchFetchDealerConfigurationCheck(),
    watchFetchCustomerJourneyInformation(),
    watchSavePublicContext(),
    watchSteps(),
    watchFetchFleetbackInterventions(),
    watchPolicyDocument()
  ])
}
